import { render, staticRenderFns } from "./ClientViewSidebarTags.vue?vue&type=template&id=4b65fee9&scoped=true"
import script from "./ClientViewSidebarTags.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarTags.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarTags.vue?vue&type=style&index=0&id=4b65fee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65fee9",
  null
  
)

export default component.exports